import { createFileRoute } from "@tanstack/react-router";
import { SellFlow } from "@/components/SellFlow";

export const Route = createFileRoute("/en/create")({
  head: () => ({
    meta: [
      { title: "Create a listing – photograph and publish for free | Sellavo" },
      { name: "description", content: "Photograph your item and Sellavo writes the title, description and price for you." },
      { property: "og:title", content: "Create a listing – photograph and publish for free | Sellavo" },
      { property: "og:description", content: "Photograph your item and Sellavo writes the title, description and price for you." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/create" }],
  }),
  component: () => <SellFlow variant="create" />,
});
